import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { AppliedRefinement } from '../Refinements/AppliedRefinement';
import { ClearButton } from './ClearButton';
import { getChipText } from '../../utils/fulfillment-helpers';

export const AppliedFiltersChips = ({
  appliedRefinements,
  desktopSort,
  enableClearAll,
  isMobile,
  onClearAll,
  onDisplay,
  onDisplayChange,
  onFiltersChipChange,
  isPlpSpeedEnabled
}) => {
  if (!appliedRefinements?.length) {
    return null;
  }

  const showClearAllButton = enableClearAll && appliedRefinements.length > 1;

  const chipsClasses = classNames(
    'sui-flex sui-flex-nowrap md:sui-flex-wrap sui-gap-2',
    { 'sui-pt-1': isPlpSpeedEnabled }
  );

  return (
    <div className={chipsClasses}>
      {showClearAllButton && (
        <div className="md:sui-hidden">
          <ClearButton onClick={onClearAll} />
        </div>
      )}
      {appliedRefinements.map((refinement, index) => {
        const {
          dimensionName,
          refinementLabel,
          refinementKey,
          url
        } = refinement;

        const [displayedDimension, displayedRefinement] = getChipText(
          dimensionName, refinementLabel, isPlpSpeedEnabled
        );

        return (
          <AppliedRefinement
            key={`${displayedDimension}-${refinementKey}`}
            index={index}
            deselectUrl={url}
            dimensionName={displayedDimension}
            label={displayedRefinement}
            refinementKey={refinementKey}
            onChange={(refinementLabel === 'On Display') ? onDisplayChange : onFiltersChipChange}
            onDisplay={onDisplay}
            desktopSort={desktopSort}
          />
        );
      })}
      {showClearAllButton && (
        <div className="sui-hidden md:sui-block">
          <ClearButton onClick={onClearAll} />
        </div>
      )}
    </div>
  );
};

AppliedFiltersChips.propTypes = {
  appliedRefinements: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  desktopSort: PropTypes.string.isRequired,
  enableClearAll: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool.isRequired,
  onClearAll: PropTypes.func.isRequired,
  onDisplay: PropTypes.string,
  onDisplayChange: PropTypes.func,
  onFiltersChipChange: PropTypes.func.isRequired,
  isPlpSpeedEnabled: PropTypes.bool
};

AppliedFiltersChips.defaultProps = {
  onDisplay: 'false',
  onDisplayChange: () => {},
  isPlpSpeedEnabled: false
};